module.exports = __webpack_public_path__ + "img/Icon material-cancel.86c13d1e.svg";